import { ReactComponent as Icon } from 'assets/menuWide/pokerVertical.svg'
import React from 'react'

export default function VerticalsPokerIcon(props: any) {
  return (
    <Icon {...props} />
  )
}